export default __webpack_public_path__ + "static/media/CrowdfundingFijo.cd39cad7.svg";